(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["property-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-format-sqft').forEach((el) => {
      const value = Number(el.dataset.value);

      if (!isNaN(value)) {
        el.textContent = value.toLocaleString('en-US');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
